import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDropdownData } from '../../types/general.types';
import { DropdownService } from '../../../../services/dropdown.service';
import { FormValidationService } from '../../services/form-validation/form-validation.service';
import { ITemplateFile } from '../../types/i-file.types';
import { FileUploaderServices } from './file-uploader.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { FileDownloaderDialogComponent } from './file-downloader-dialog/file-downloader-dialog.component';
import { NotificationsService } from '../../services/notifications.service';
import { NPA_ALERTS } from '../../consts/messages';
import { TranslateService } from '../../services/translate.service';
import { composeMessage } from '../../consts/errors';

@Component({
    selector: 'npa-file-uploader',
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.styl']
})
export class FileUploaderComponent implements OnInit, OnChanges {
    @ViewChild('inputFile', { static: false }) nativeInputFile: ElementRef;
    @Input() isMultiple = false;
    @Input() required = true;
    selectedFile: any = {};
    @Input() detectChange: any;
    @Input() templateData: ITemplateFile;
    form: FormGroup;
    isSelected = false;
    languages = [];
    privacyStatus = [
        {
            name_ps: "عام",
            name_prs: "عام",
            name_en: "Public",
            slug: "public",
        },
        {
            name_ps: "نورمال",
            name_prs: "نورمال",
            name_en: "Normal",
            slug: "normal",
        },
        {
            name_ps: "محرم",
            name_prs: "محرم",
            name_en: "Confidential",
            slug: "confidential",
        },
        {
            name_ps: "اشد محرم",
            name_prs: "اشد محرم",
            name_en: "Strictly Confidential",
            slug: "strictly-confidential",
        },
    ];
    @Input() resourceValue!: string;
    @Input() componentSlug!: string;
    @Input() isMisc: boolean = false;
    @Input() docTitle: string;
    showAddFile: boolean = true;
    @Output() fileUploadStatus = new EventEmitter<boolean>();
    showUploadedFilesBtn: boolean = false;

    constructor(public dropdownService: DropdownService,
        public formValidationService: FormValidationService,
        public notificationsService: NotificationsService,
        public translateService: TranslateService,
        private formBuilder: FormBuilder,
        private fileUploaderService: FileUploaderServices,
        public dialog: MatDialog) {
    }

    ngOnInit() {
        this.fileUploaderService.hasFile(this.resourceValue).subscribe(result => {
            if (result.isFile == true) {
                this.required = false;
                if (!this.isMisc) {
                    this.showAddFile = false
                }
                this.showUploadedFilesBtn = true
            }
        })
        if (this.isMisc == true) {
            this.docTitle = null
        }
        this.form = this.formBuilder.group({
            docTitle: this.docTitle,
            title: [
                this.templateData && this.templateData.slug,
                this.required ? Validators.compose(
                    [this.formValidationService.required.validator, this.formValidationService.properText.validator]) : Validators.nullValidator
            ],
            summary: [
                this.templateData && this.templateData.slug,
                this.required ? Validators.compose(
                    [this.formValidationService.required.validator, this.formValidationService.properText.validator]) : Validators.nullValidator
            ],
            language: [undefined, this.required ? this.formValidationService.required.validator : Validators.nullValidator],
            privacyStatus: [undefined, this.required ? this.formValidationService.required.validator : Validators.nullValidator],
            resourceValue: this.resourceValue,
            componentSlug: this.componentSlug
        }
        );
        this.dropdownService.getData('commons', 'language')
            .subscribe((data: IDropdownData[]) => {
                this.languages = data;
            }, (error) => {
                console.error(error);
            });
        // this.dropdownService.getData('references', 'privacy-status')
        //     .subscribe((data: IDropdownData[]) => {
        //         this.privacyStatus = data;
        //     }, (error) => {
        //         console.error(error);
        //     });
    }

    selectFile(): void {
        this.nativeInputFile.nativeElement.click();
    }

    ngOnChanges() {
        if (!this.detectChange) {
            this.isSelected = false;
            this.selectedFile = {};
        }
    }

    onFileChange(event) {
        if (event.target.files && event.target.files.length > 0) {
            const file: File = event.target.files[0] as File;
            this.isSelected = true;
            this.selectedFile['name'] = file && file.name;
            this.selectedFile['size'] = file && file.size;
            this.selectedFile['type'] = file && file.type;
            this.selectedFile['file'] = file;
        }

    }

    getFileNameWidth(container: HTMLDivElement): string {
        return (container.clientWidth - 870) + 'px';
    }

    deleteUploadedFile() {
        this.isSelected = false;
        this.nativeInputFile.nativeElement.value = '';
        this.selectedFile = {};
    }

    isValid() {
        let isValid = this.form.valid;
        if (this.isMisc) {
            if (this.form.get('title').value !== null &&
                this.form.get('summary').value !== null &&
                this.form.get('language').value !== null &&
                this.form.get('privacyStatus').value !== null &&
                this.isSelected &&
                this.form.valid) {
                isValid = true;
            } else {
                isValid = false;
            }
        } else {
            if (this.form.get('docTitle').value !== null &&
                this.form.get('language').value !== null &&
                this.form.get('privacyStatus').value !== null &&
                this.isSelected
            ) {
                isValid = true;
            } else {
                isValid = false;
            }
        }
        return isValid;
    }

    save() {
        const formData = this.form.value;
        this.fileUploaderService
            .store({ ...formData, attachments: this.selectedFile }, [])
            .subscribe(
                (result) => {
                    if (result.status == 200) {
                        this.notificationsService.success(NPA_ALERTS[this.translateService.lang].ADD_SUCCESS);
                        this.fileUploadStatus.emit(true);
                        this.required = false;
                        this.ngOnInit();
                        this.showUploadedFilesBtn = true
                        this.deleteUploadedFile();
                    } else {
                        this.fileUploadStatus.emit(false);
                    }
                },
                (error: HttpErrorResponse) => {
                    this.notificationsService.error(composeMessage(error));
                    console.error(error);
                }
            );
    }

    openDialog() {
        this.dialog.open(FileDownloaderDialogComponent, {
            disableClose: true,
            width: '1000px',
            data: {
                resourceValue: this.resourceValue
            }
        }).afterClosed().subscribe((result) => {
            if (result.isFileEmpty) {
                this.fileUploadStatus.emit(false);
                this.required = true;
                this.showUploadedFilesBtn = false
                if (!this.isMisc) {
                    this.showAddFile = true
                }
            }
        });
    }

}
